
// container must be an element higher up the tree than the gallery
theme.initProductGallery = function (container) {
  var $gallery = $(".gallery", container);
  if ($gallery.hasClass("gallery-initialised")) {
    return;
  }

  $gallery.addClass("gallery-initialised");

  /// Variant grouping
  if (
    $gallery.data("variant-image-grouping") &&
    $gallery.data("variant-image-grouping-option-index") !== ""
  ) {
    var productData = theme.OptionManager.getProductData(
        $gallery.closest(".product-detail").find(".product-form")
      ),
      groupingOptionIndex = $gallery.data(
        "variant-image-grouping-option-index"
      );
    // build map of grouping options and featured media
    var optionNameMediaMap = {};
    productData.media.forEach((media) => {
      productData.variants.forEach((variant) => {
        if (variant.featured_media && variant.featured_media.id == media.id) {
          if (!optionNameMediaMap[variant.options[groupingOptionIndex]]) {
            optionNameMediaMap[variant.options[groupingOptionIndex]] = media.id;
          }
        }
      });
    });
    // set option name on each image
    var currentMediaOptionName = "";
    $gallery.find(".slide").each(function (index, item) {
      for (var optionName in optionNameMediaMap) {
        if ($(item).data("media-id") == optionNameMediaMap[optionName]) {
          currentMediaOptionName = optionName;
        }
      }
      $(item).attr("data-variant-image-group", currentMediaOptionName);
    });
    currentMediaOptionName = "";
    $gallery.find(".thumbnail").each(function (index, item) {
      for (var optionName in optionNameMediaMap) {
        if ($(item).data("media-id") == optionNameMediaMap[optionName]) {
          currentMediaOptionName = optionName;
        }
      }
      $(item).attr("data-variant-image-group", currentMediaOptionName);
    });
  }

  /// Init main image slideshow
  var $slideshow = $(".product-slideshow", container);
  if ($slideshow.length) {
    var slickConfig = {
      autoplay: false,
      fade: false,
      infinite: false,
      useTransform: true,
      dots: false,
      arrows: false,
      waitForAnimate: false,
      appendArrows: $slideshow
        .siblings(".slideshow-controls")
        .find(".slideshow-controls__arrows"),
      prevArrow:
        '<button type="button" class="slick-product-prev" aria-label="' +
        theme.strings.previous +
        '">' +
        theme.icons.chevronLeft +
        "</button>",
      nextArrow:
        '<button type="button" class="slick-product-next" aria-label="' +
        theme.strings.next +
        '">' +
        theme.icons.chevronRight +
        "</button>",
      mobileFirst: true,
      rtl: document.querySelector("html[dir=rtl]") ? true : false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            fade: true,
            arrows: true,
          },
        },
      ],
    };

    $slideshow
      .on("init", function (evt, slick) {
        $(".lazyload--manual", this)
          .removeClass("lazyload--manual")
          .addClass("lazyload");
      })
      .on("beforeChange", function (evt, slick, current, next) {
        var mediaId = $(slick.$slides[next]).data("media-id");
        $(
          $(this)
            .closest(".gallery")
            .find(
              '.thumbnails:not(.hidden) .thumbnail[data-media-id="' +
                mediaId +
                '"]'
            )
        ).trigger("selectFromSlick");
      });

    if (
      $slideshow.closest(
        ".gallery--layout-carousel-beside, .gallery--layout-carousel-under"
      ).length
    ) {
      // carousel layout - slideshow all the time
      $slideshow.slick(slickConfig);
    } else {
      // collage layout - slideshow on mobile only
      var enforceMobileSlideshow = function enforceMobileSlideshow() {
        if ($(window).width() < 768) {
          $slideshow.not(".slick-slider").each(function () {
            // remove desktop collage filter classes
            $(this)
              .find(".slide--inactive-option")
              .removeClass("slide--inactive-option");
            // init slideshow
            $(this).slick(slickConfig);
            // trigger variant select
            $(this)
              .closest(".product-detail")
              .find(".original-selector")
              .trigger("change");
          });
        } else {
          $slideshow.filter(".slick-slider").each(function () {
            $(this).slick("slickUnfilter").slick("unslick");
            // trigger variant select
            $(this)
              .closest(".product-detail")
              .find(".original-selector")
              .trigger("change");
          });
        }
      };
      enforceMobileSlideshow();
      $(window).on("debouncedresize.productGallery", enforceMobileSlideshow);
    }

    // media initialisation
    theme.ProductMedia.init($gallery, {
      onYoutubeInit: function onYoutubeInit(playerObj) {
        if ($slideshow.hasClass("slick-slider")) {
          theme.productGallerySlideshowTabFix(
            $slideshow.slick("getSlick").$slides,
            $slideshow.slick("getSlick").currentSlide
          );
        }
      },
      onModelViewerInit: function onModelViewerInit(element) {
        if ($slideshow.hasClass("slick-slider")) {
          theme.productGallerySlideshowTabFix(
            $slideshow.slick("getSlick").$slides,
            $slideshow.slick("getSlick").currentSlide
          );
        }
      },
      onVideoVisible: function onVideoVisible(e) {
        if ($(window).width() >= 768) {
          $(e.target)
            .closest(".slick-slider")
            .slick("slickSetOption", "swipe", false);
        }
      },
      onModelViewerPlay: function onModelViewerPlay(e) {
        // prevent swiping
        $(e.target)
          .closest(".slick-slider")
          .slick("slickSetOption", "swipe", false);
        // prevent left/right key control
        $(e.target)
          .closest(".slick-slider")
          .slick("slickSetOption", "accessibility", false);
      },
      onModelViewerPause: function onModelViewerPause(e) {
        $(e.target)
          .closest(".slick-slider")
          .slick("slickSetOption", "swipe", true);
        $(e.target)
          .closest(".slick-slider")
          .slick("slickSetOption", "accessibility", true);
      },
    });

    // fix tabindex for first slide
    if ($slideshow.hasClass("slick-slider")) {
      theme.productGallerySlideshowTabFix(
        $slideshow.slick("getSlick").$slides,
        $slideshow.slick("getSlick").currentSlide
      );
    }

    $slideshow.on("afterChange", function (evt, slick, current) {
      // reset playing media
      theme.pauseAllMedia();
      if ($(window).width() >= 768) {
        slick.slickSetOption("swipe", true);
      }
      // notify media of visibility
      $(".product-media", slick.$slides[current]).trigger("mediaVisible");
      // slideshow tab fix
      theme.productGallerySlideshowTabFix(slick.$slides, current);
    });
  }

  var $thumbnails = $(".thumbnails:not(.hidden)", container);
  if ($thumbnails.length) {
    var carouselVisibleItemCount = 6,
      isCarousel = false;

    /// Screen-width based initialisation of thumbnail carousels
    var assessCarousel = function assessCarousel() {
      if ($thumbnails.parent().css("display") == "flex") {
        // thumbnail container is in column beside main image - destroy carousel
        if (isCarousel) {
          isCarousel = false;

          theme.beforeCarouselUnloadEventBlockFix($thumbnails);
          $thumbnails
            .removeClass("owl-carousel")
            .data("owl.carousel")
            .destroy();

          // trigger variant image grouping
          $gallery
            .closest(".product-detail")
            .find(".original-selector")
            .trigger("change");
        }
      } else {
        // thumbnails underneath - init carousel
        if (!isCarousel) {
          isCarousel = true;

          // fix for event propagation in nested owl carousels
          theme.beforeCarouselLoadEventBlockFix($thumbnails);

          // reset any image grouping modifications
          $thumbnails.find(".thumbnail").show();
          $gallery.find(".hidden-thumbnails").children().appendTo($thumbnails);

          $thumbnails
            .addClass("owl-carousel")
            .on("initialized.owl.carousel", function () {
              $(".lazyload--manual", this)
                .removeClass("lazyload--manual")
                .addClass("lazyload");
            })
            .owlCarousel({
              items: carouselVisibleItemCount,
              dots: false,
              margin: 7,
              rtl: document.querySelector("html[dir=rtl]") ? true : false,
            });

          // trigger variant image grouping
          $gallery
            .closest(".product-detail")
            .find(".original-selector")
            .trigger("change");
        }
      }
    };

    $(window).on("debouncedresize.productGallery", assessCarousel);
    assessCarousel();
    $(container).data("assessCarouselCallback", assessCarousel);

    /// Thumbnail click - in carousel
    // Events:
    // click: click on a thumbnail
    // select: selection via variant image
    // selectFromSlick: change of main image
    //
    // 'selectFromSlick' is treated as the 'primary' driver of state change, select/click to just update the main image slideshow,
    // and an after-transition callback updates the thumbnail
    $(".gallery", container).on(
      "click select selectFromSlick",
      ".thumbnails.owl-carousel .thumbnail",
      function (e) {
        e.preventDefault();
        var $carouselItem = $(this).parent();
        if (e.type != "selectFromSlick") {
          // from click or variant image? change main image
          var mediaId = $(this).data("media-id");
          var _$slideshow = $(this)
            .closest(".gallery")
            .find(".slideshow.slick-slider");
          if (_$slideshow) {
            var index = _$slideshow
              .find('.slide[data-media-id="' + mediaId + '"]')
              .index(); // current index including filters
            // same index? manual trigger of next event
            var slick = _$slideshow.slick("getSlick");
            if (slick.currentSlide === index) {
              // current slide active, manually trigger from-slick thumb selection (req. for index changes during filtering)
              $(this).trigger("selectFromSlick");
            } else {
              // change slide
              console.log("I?m here ")
              //_$slideshow.slick("slickGoTo", index);
            }
          }
        } else {
          // change to active state comes from the main slideshow change event
          // show the highlight
          $(this)
            .addClass("selected")
            .parent()
            .siblings()
            .find("a")
            .removeClass("selected");

          // adjust thumbnail carousel if not on-screen
          var shelfStart = $carouselItem
            .parent()
            .children(".active:first")
            .index();
          var shelfEnd = shelfStart + carouselVisibleItemCount - 1;
          var currentIndex = $carouselItem.index();

          if (currentIndex < shelfStart) {
            // selected is to left of shelf - move carousel right to show
            $carouselItem
              .closest(".owl-carousel")
              .trigger("to.owl.carousel", currentIndex);
          } else if (currentIndex > shelfEnd) {
            // selected is to right of shelf - move carousel left to show
            $carouselItem
              .closest(".owl-carousel")
              .trigger(
                "to.owl.carousel",
                Math.max(0, currentIndex - carouselVisibleItemCount + 1)
              );
          }
        }
      }
    );

    /// Thumbnail click - beside
    // Uses same event structure as the events above ^
    $(".gallery", container).on(
      "click select selectFromSlick",
      " .thumbnails:not(.owl-carousel) .thumbnail",
      function (e) {
        e.preventDefault();
        if (e.type != "selectFromSlick") {
          // from click or variant image? change main image
          var index = 0;
          var mediaId = $(this).data("media-id");
          $(this)
            .parent()
            .children(":visible")
            .each(function (iter) {
              index = iter;
              if ($(this).data("media-id") == mediaId) {
                return false;
              }
            });
          // same index? manual trigger of next event
          var _$slideshow2 = $(this).closest(".gallery").find(".slideshow");
          var slick = _$slideshow2.slick("getSlick");
          if (slick.currentSlide === index) {
            // current slide active, manually trigger from-slick thumb selection (req. for index changes during filtering)
            $(this).trigger("selectFromSlick");
          } else {
            // change slide
            _$slideshow2.slick("slickGoTo", index);
          }
        } else {
          // change to active state comes from the main slideshow change event
          $(this)
            .addClass("selected")
            .siblings(".selected")
            .removeClass("selected");
        }
      }
    );
  }
};

theme.destroyProductGallery = function (container) {
  $(window).off(".productGallery");
  var $gallery = $(".gallery", container).off("click select selectFromSlick");
  theme.ProductMedia.destroy($gallery);
  $(".slick-slider", container)
    .slick("unslick")
    .off("init beforeChange afterChange");
  $(".owl-carousel", container).each(function () {
    theme.beforeCarouselUnloadEventBlockFix(this);
    $(this).data("owl.carousel").destroy();
  });
};

/* Product Media
 *
 * Load and destroy:
 * theme.ProductMedia.init(galleryContainer, {
 *   onModelViewerPlay: function(e){
 *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', false);
 *   },
 *   onModelViewerPause: function(e){
 *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', true);
 *   }
 * });
 *
 * theme.ProductMedia.destroy(galleryContainer);
 */
theme.ProductMedia = new (function () {
  var _ = this;

  _._setupShopifyXr = function () {
    if (!window.ShopifyXR) {
      document.addEventListener(
        "shopify_xr_initialized",
        _._setupShopifyXr.bind(this)
      );
      return;
    }

    window.ShopifyXR.addModels(JSON.parse($(this).html()));
    window.ShopifyXR.setupXRElements();
  };

  this.init = function (container, callbacks) {
    var callbacks = callbacks || {},
      _container = container;

    // set up video media elements with a controller
    $(container)
      .find(".product-media--video")
      .each(function (index) {
        var poster = this.querySelector(".product-media__poster");
        $(".product-media__video-play-btn", poster).on("click", function () {
          $(this).closest(".product-media--video").data("player").play();
        });

        var playerObj = { container: this, poster: poster };
        playerObj.play = function () {
          // pause anything else
          theme.pauseAllMedia();

          // hide poster
          this.poster.classList.add("product-media__poster--hide");
          $(this).closest(".slick-slider").slick("setPosition");

          // play
          this.container.querySelectorAll(".js-youtube").forEach((video) => {
            video.contentWindow.postMessage(
              '{"event":"command","func":"playVideo","args":""}',
              "*"
            );
          });
          this.container.querySelectorAll(".js-vimeo").forEach((video) => {
            video.contentWindow.postMessage('{"method":"play"}', "*");
          });
          this.container
            .querySelectorAll("video")
            .forEach((video) => video.play());
        }.bind(playerObj);

        // instantiate videos
        var template = this.querySelector(".product-media__video-template");
        if (template) {
          this.insertAdjacentHTML("beforeend", template.innerHTML);
          this.removeChild(template);
          this.style.paddingBottom =
            100 /
              this.querySelector("video, iframe").getAttribute("aspect-ratio") +
            "%";
        }

        $(this)
          .data("player", playerObj)
          .addClass("product-media--video-loaded");
      });

    // when any media appears
    $(container).on(
      "mediaVisible",
      ".product-media--video-loaded, .product-media--model-loaded",
      function () {
        // autoplay all media on larger screens
        if ($(window).width() >= 768) {
          $(this).data("player").play();
        }
        // update view-in-space
        if ($(this).hasClass("product-media--model")) {
          $(".view-in-space", _container).attr(
            "data-shopify-model3d-id",
            $(this).data("model-id")
          );
        }
      }
    );

    // necessary callbacks
    if (callbacks.onVideoVisible) {
      $(container).on(
        "mediaVisible",
        ".product-media--video-loaded",
        callbacks.onVideoVisible
      );
    }

    $("model-viewer", container).each(function () {
      if (callbacks.onModelViewerPlay) {
        $(this).on(
          "shopify_model_viewer_ui_toggle_play",
          callbacks.onModelViewerPlay
        );
      }
      if (callbacks.onModelViewerPause) {
        $(this).on(
          "shopify_model_viewer_ui_toggle_pause",
          callbacks.onModelViewerPause
        );
      }
    });

    // set up a 3d model when it first appears
    $(container).on(
      "mediaVisible mediaVisibleInitial",
      ".product-media--model:not(.product-media--model-loaded)",
      function (e) {
        var element = $(this).find("model-viewer")[0],
          autoplay = e.type != "mediaVisibleInitial";
        // load viewer
        theme.loadStyleOnce(
          "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"
        );
        window.Shopify.loadFeatures([
          {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: function () {
              $(this).data("player", new Shopify.ModelViewerUI(element));
              // set class and re-trigger visible event now loaded
              $(this).addClass("product-media--model-loaded");
              if (callbacks.onModelViewerInit) {
                callbacks.onModelViewerInit(element);
              }
              if (autoplay) {
                $(this).trigger("mediaVisible");
              }
            }.bind(this),
          },
        ]);
      }
    );

    // load AR viewer
    if ($(".model-json", container).length) {
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: _._setupShopifyXr.bind($(".model-json", container)),
        },
      ]);
    }

    // pause other media when a 3d model is launched in AR
    $(document).on("shopify_xr_launch", function () {
      theme.pauseAllMedia({ videos: true });
    });

    // 3d model in first place - start in paused mode
    setTimeout(
      function () {
        $(".product-slideshow.slick-slider .product-media:first", this)
          .filter(".product-media--model")
          .trigger("mediaVisibleInitial");
        $(
          ".product-slideshow:not(.slick-slider) .product-media--model",
          this
        ).trigger("mediaVisibleInitial");
      }.bind(container),
      50
    );
  };

  this.destroy = function (container) {
    $(document).off("shopify_xr_launch");
    $(container).off("mediaVisible mediaVisibleInitial");
    $(".product-media--model-loaded", container).each(function () {
      $(this).data("player").destroy();
    });
    $(".product-media--video video", container).off("playing pause ended");
    $("model-viewer", container).off(
      "shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause"
    );
  };
})();

theme.productGallerySlideshowTabFix = function (slides, current) {
  // tabindex everything to prevent tabbing into hidden slides
  $(slides[current])
    .find("a, input, button, select, iframe, video, model-viewer, [tabindex]")
    .each(function () {
      if (
        typeof $(this).data("theme-slideshow-original-tabindex") !== "undefined"
      ) {
        if ($(this).data("theme-slideshow-original-tabindex") === false) {
          $(this).removeAttr("tabindex");
        } else {
          $(this).attr(
            "tabindex",
            $(this).data("theme-slideshow-original-tabindex")
          );
        }
      } else {
        $(this).removeAttr("tabindex");
      }
    });
  $(slides)
    .not(slides[current])
    .find("a, input, button, select, iframe, video, model-viewer, [tabindex]")
    .each(function () {
      if (
        typeof $(this).data("theme-slideshow-original-tabindex") === "undefined"
      ) {
        $(this).data(
          "theme-slideshow-original-tabindex",
          typeof $(this).attr("tabindex") !== "undefined"
            ? $(this).attr("tabindex")
            : false
        );

        $(this).attr("tabindex", "-1");
      }
    });
};

// Manage option dropdowns
theme.productData = {};
theme.OptionManager = new (function () {
  var _ = this;

  _._getVariantOptionElement = function (variant, $container) {
    return $container.find(
      'select[name="id"] option[value="' + (variant ? variant.id : "") + '"]'
    );
  };

  _.selectors = {
    container: ".product-detail",
    gallery: ".gallery",
    priceArea: ".price-area",
    variantIdInputs: '[name="id"]',
    purchaseForm: ".product-purchase-form",
    primaryVariantIdInput: '.product-purchase-form [name="id"]',
    submitButton: '.product-purchase-form button[type="submit"]',
    multiOption: ".option-selectors",
    customOption: ".custom-option",
    installmentsFormSuffix: "-installments",
  };

  _.strings = {
    buttonDefault: theme.strings.products_product_add_to_cart,
    buttonNoStock: theme.strings.products_variant_no_stock,
    buttonNoVariant: theme.strings.products_variant_non_existent,
  };

  _.getProductData = function ($form) {
    var productId = $form.data("product-id");
    var data = null;
    if (!theme.productData[productId]) {
      theme.productData[productId] = JSON.parse(
        document.getElementById("ProductJson-" + productId).innerHTML
      );
    }
    data = theme.productData[productId];
    if (!data) {
      console.log(
        "Product data missing (id: " + $form.data("product-id") + ")"
      );
    }
    return data;
  };

  _.getVariantFromId = function ($productForm, id) {
    var variants = this.getProductData($productForm).variants;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id == id) {
        return variants[i];
      }
    }
    return { available: false };
  };

  _.getCurrentVariantData = function ($productForm) {
    return _.getVariantFromId(
      $productForm,
      $productForm.find(_.selectors.primaryVariantIdInput).val()
    );
  };

  (_.getBaseUnit = function (variant) {
    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }),
    (_.addVariantUrlToHistory = function (variant) {
      if (variant) {
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      }
    });

  _.updateSku = function (variant, $container) {
    $container.find(".sku .sku__value").html(variant ? variant.sku : "");
    $container
      .find(".sku")
      .toggleClass("sku--no-sku", !variant || !variant.sku);
  };

  _.updateBarcode = function (variant, $container) {
    $container
      .find(".barcode .barcode__value")
      .html(variant ? variant.barcode : "");
    $container
      .find(".barcode")
      .toggleClass("barcode--no-barcode", !variant || !variant.barcode);
  };

  _.updateTransferNotice = function (variant, $container) {
    var transferData = _._getVariantOptionElement(variant, $container).data(
      "inventory-transfer"
    );
    if (transferData) {
      $container
        .find(".product-inventory-transfer")
        .removeClass("product-inventory-transfer--none")
        .html(transferData);
    } else {
      $container
        .find(".product-inventory-transfer")
        .addClass("product-inventory-transfer--none")
        .empty();
    }
  };

  _.updateVariantDeterminedVisibilityAreas = function (variant, $container) {
    $container.find(".variant-visibility-area").each(function () {
      $(this).children(":not(script)").remove();
      if (variant) {
        $(this).append(
          $(this)
            .children('script[data-variant-id="' + variant.id + '"]')
            .html()
        );
      } else {
        $(this).append($(this).children('script[data-variant-id=""]').html());
      }
    });
  };

  _.updateBackorder = function (variant, $container) {
    var $backorder = $container.find(".backorder");
    if ($backorder.length) {
      if (variant && variant.available) {
        if (
          variant.inventory_management &&
          _._getVariantOptionElement(variant, $container).data("stock") == "out"
        ) {
          var productData = _.getProductData(
            $backorder.closest(".product-form")
          );
          $backorder
            .find(".backorder__variant")
            .text(
              productData.title +
                (variant.title.indexOf("Default") >= 0
                  ? ""
                  : " - " + variant.title)
            );
          $backorder.show();
        } else {
          $backorder.hide();
        }
      } else {
        $backorder.hide();
      }
    }
  };

  _._updateButtonText = function ($button, string, variant) {
    $button.each(function () {
      var newVal;
      newVal = _.strings["button" + string];
      if (newVal !== false) {
        if ($(this).is("input")) {
          $(this).val(newVal);
        } else {
          $(this).html(newVal);
        }
      }
    });
  };

  _.updateButtons = function (variant, $container) {
    var $button = $container.find(_.selectors.submitButton);

    if (variant) {
      $button.removeAttr("disabled");
      if (variant.available == true) {
        _._updateButtonText($button, "Default", variant);
      } else {
        _._updateButtonText($button, "NoStock", variant);
      }
    } else {
      if (theme.getEmptyOptionSelectors($container).length) {
        $button.removeAttr("disabled");
        _._updateButtonText($button, "Default", variant);
      } else {
        $button.attr("disabled", "disabled");
        _._updateButtonText($button, "NoVariant", variant);
      }
    }
  };

  _.updateContainerStatusClasses = function (variant, $container) {
    $container.toggleClass("variant-status--not-selected", !variant);
    $container.toggleClass(
      "variant-status--unavailable",
      variant && !variant.available
    );
    $container.toggleClass(
      "variant-status--backorder",
      variant &&
        variant.available &&
        variant.inventory_management &&
        _._getVariantOptionElement(variant, $container).data("stock") == "out"
    );
    $container.toggleClass(
      "variant-status--on-sale",
      variant && variant.available && variant.compare_at_price > variant.price
    );
  };

  _.initProductOptions = function ($productForm) {
    if ($productForm.hasClass("theme-init")) return;

    var productData = _.getProductData($productForm);
    $productForm.addClass("theme-init");

    // init option selectors
    $productForm
      .find(_.selectors.multiOption)
      .on("change.themeProductOptions", function () {
        var selectedOptions = [];
        $(this)
          .find(".option-selector")
          .each(function () {
            if ($(this).data("selector-type") === "listed") {
              selectedOptions.push($(this).find(".js-option:checked").val());
            } else {
              selectedOptions.push(
                $(this).find('.js-option[aria-selected="true"]').data("value")
              );
            }
          });

        // find variant
        var variant = false;
        for (var i = 0; i < productData.variants.length; i++) {
          var v = productData.variants[i];
          var matchCount = 0;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (v.options[j] == selectedOptions[j]) {
              matchCount++;
            }
          }
          if (matchCount == selectedOptions.length) {
            variant = v;
            break;
          }
        }

        // trigger change
        $productForm.find(_.selectors.variantIdInputs).val(variant.id);

        // a jQuery event may not be picked up by all listeners
        $productForm.find(_.selectors.variantIdInputs).each(function () {
          this.dispatchEvent(
            new CustomEvent("change", {
              bubbles: true,
              cancelable: false,
              detail: { variant: variant, selectedOptions: selectedOptions },
            })
          );
        });
      });

    // init custom options (mirror in purchase form for Buy Now button)
    $productForm
      .find(_.selectors.customOption)
      .each(function () {
        var $input = $(this).find("input:first, textarea, select");
        $('<input type="hidden">')
          .attr({
            name: $input.attr("name"),
            value: $input.val(),
          })
          .appendTo($productForm.find(_.selectors.purchaseForm));
      })
      .on("change.themeProductOptions", function () {
        var $radios = $(this).find('input[type="radio"]'),
          $checkbox = $(this).find('input[type="checkbox"]');
        if ($radios.length) {
          // radio buttons
          $productForm
            .find(_.selectors.purchaseForm + " input")
            .filter(function () {
              return this.name === $radios[0].name;
            })
            .val($radios.filter(":checked").val())
            .trigger("change");
        } else if ($checkbox.length) {
          // checkbox
          var val = null;
          if ($checkbox.is(":checked")) {
            val = $checkbox.val();
          } else {
            val = $checkbox.siblings('[type="hidden"]').val();
          }
          $productForm
            .find(_.selectors.purchaseForm + " input")
            .filter(function () {
              return this.name === $checkbox[0].name;
            })
            .val(val)
            .trigger("change");
        } else {
          // other inputs
          var $input = $(this).find("select, input, textarea");
          $productForm
            .find(_.selectors.purchaseForm + " input")
            .filter(function () {
              return this.name === $input.attr("name");
            })
            .val($input.val())
            .trigger("change");
        }
      });

    // init variant ids
    $productForm.find(_.selectors.primaryVariantIdInput).each(function () {
      // change state for original dropdown
      $(this).on(
        "change.themeProductOptions firstrun.themeProductOptions",
        function (e) {
          if ($(this).is("input[type=radio]:not(:checked)")) {
            return; // handle radios - only update for checked
          }
          // If variant is passed in, use that. Even if 'false'. If nothing is passed, find from input value.
          var variant = e.detail ? e.detail.variant : null;
          if (!variant && variant !== false) {
            for (var i = 0; i < productData.variants.length; i++) {
              if (productData.variants[i].id == $(this).val()) {
                variant = productData.variants[i];
              }
            }
          }
          var $container = $(this).closest(_.selectors.container);

          // string overrides
          var $addToCart = $container
            .find(_.selectors.submitButton)
            .filter("[data-add-to-cart-text]");
          if ($addToCart.length) {
            _.strings.buttonDefault = $addToCart.data("add-to-cart-text");
          }

          // update buttons
          _.updateButtons(variant, $container);

          // emit an event to broadcast the variant update
          $(window).trigger("cc-variant-updated", {
            variant: variant,
            product: productData,
          });

          // variant images
          if (variant && variant.featured_media) {
            // variant passed
            $container
              .find(_.selectors.gallery)
              .trigger("variantImageSelected", [
                variant,
                e.type === "firstrun",
              ]);
          } else if (e.detail && e.detail.selectedOptions) {
            // if some options selected, find the first matching variant for image
            var matchesRequired = e.detail.selectedOptions.filter(
              (o) => o.length > 0
            ).length;
            if (matchesRequired > 0) {
              for (var i = 0; i < productData.variants.length; i++) {
                var v = productData.variants[i];
                var matchCount = 0;
                for (var j = 0; j < e.detail.selectedOptions.length; j++) {
                  if (v.options[j] == e.detail.selectedOptions[j]) {
                    matchCount++;
                  }
                }
                if (matchCount == matchesRequired && v.featured_media) {
                  $container
                    .find(_.selectors.gallery)
                    .trigger("variantImageSelected", [
                      v,
                      e.type === "firstrun",
                    ]);
                  break;
                }
              }
            }
          }

          // extra details
          _.updateBarcode(variant, $container);
          _.updateSku(variant, $container);
          _.updateTransferNotice(variant, $container);
          _.updateVariantDeterminedVisibilityAreas(variant, $container);
          _.updateBackorder(variant, $container);
          _.updateContainerStatusClasses(variant, $container);

          // variant urls
          if ($productForm.data("enable-history-state") && e.type == "change") {
            _.addVariantUrlToHistory(variant);
          }

          // allow other things to hook on
          $productForm.trigger("variantChanged", [variant, productData]);
        }
      );

      // first-run
      $(this).trigger("firstrun");
    });

    // ajax
    theme.applyAjaxToProductForm($productForm);

    // apply URL params
    var searchParams = new URLSearchParams(location.search);
    var _loop2 = function _loop2(key) {
      $productForm
        .find(".option-selector")
        .filter(function () {
          return this.querySelector(".label").firstChild.textContent === key;
        })
        .each(function () {
          var value = searchParams.get(key);
          if (this.dataset.selectorType == "dropdown") {
            this.querySelector(".cc-select").dispatchEvent(
              new CustomEvent("selectOption", { detail: { value: value } })
            );
          } else {
            this.querySelectorAll(".opt-label__text").forEach((el) => {
              if (el.innerText == value) {
                var input = document.getElementById(
                  el.parentElement.getAttribute("for")
                );
                if (input) {
                  input.checked = true;
                  input.dispatchEvent(
                    new CustomEvent("change", {
                      bubbles: true,
                      cancelable: false,
                    })
                  );
                }
              }
            });
          }
        });
    };
    for (var key of searchParams.keys()) {
      _loop2(key);
    }
  };

  _.unloadProductOptions = function ($productForm) {
    $productForm.removeClass("theme-init").each(function () {
      $(this).trigger("unloading").off(".themeProductOptions");
      $(this).find(_.selectors.multiOption).off(".themeProductOptions");
      $(this).find(_.selectors.customOption).off(".themeProductOptions");
      theme.removeAjaxFromProductForm($productForm);
    });
  };
})();


/**
 * StoreAvailability Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace StoreAvailability
 */

theme.StoreAvailability = function (container) {
  var loadingClass = "store-availability-loading";
  var initClass = "store-availability-initialized";
  var storageKey = "cc-location";

  this.onSectionLoad = function (container) {
    this.namespace = theme.namespaceFromSection(container);
    this.$container = $(container);
    this.productId = this.$container.data("store-availability-container");
    this.sectionUrl = this.$container.data("section-url");
    this.$modal;

    this.$container.addClass(initClass);
    this.transitionDurationMS =
      parseFloat(getComputedStyle(container).transitionDuration) * 1000;
    this.removeFixedHeightTimeout = -1;

    // Handle when a variant is selected
    $(window).on(
      "cc-variant-updated".concat(this.namespace).concat(this.productId),
      (e, args) => {
        if (args.product.id === this.productId) {
          this.functions.updateContent.bind(this)(
            args.variant ? args.variant.id : null,
            args.product.title,
            this.$container.data("has-only-default-variant"),
            args.variant && typeof args.variant.available !== "undefined"
          );
        }
      }
    );

    // Handle single variant products
    if (this.$container.data("single-variant-id")) {
      this.functions.updateContent.bind(this)(
        this.$container.data("single-variant-id"),
        this.$container.data("single-variant-product-title"),
        this.$container.data("has-only-default-variant"),
        this.$container.data("single-variant-product-available")
      );
    }
  };

  this.onSectionUnload = function () {
    $(window).off(
      "cc-variant-updated".concat(this.namespace).concat(this.productId)
    );
    this.$container.off("click");
    if (this.$modal) {
      this.$modal.off("click");
    }
  };

  this.functions = {
    // Returns the users location data (if allowed)
    getUserLocation: function getUserLocation() {
      return new Promise((resolve, reject) => {
        var storedCoords;

        if (sessionStorage[storageKey]) {
          storedCoords = JSON.parse(sessionStorage[storageKey]);
        }

        if (storedCoords) {
          resolve(storedCoords);
        } else {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              function (position) {
                var coords = {
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
                };

                //Set the localization api
                fetch("/localization.json", {
                  method: "PUT",
                  headers: {
                    "Content-Type": "application/json",
                  },

                  body: JSON.stringify(coords),
                });

                //Write to a session storage
                sessionStorage[storageKey] = JSON.stringify(coords);

                resolve(coords);
              },
              function () {
                resolve(false);
              },
              {
                maximumAge: 3600000, // 1 hour
                timeout: 5000,
              }
            );
          } else {
            resolve(false);
          }
        }
      });
    },

    // Requests the available stores and calls the callback
    getAvailableStores: function getAvailableStores(variantId, cb) {
      return $.get(this.sectionUrl.replace("VARIANT_ID", variantId), cb);
    },

    // Haversine Distance
    // The haversine formula is an equation giving great-circle distances between
    // two points on a sphere from their longitudes and latitudes
    calculateDistance: function calculateDistance(
      coords1,
      coords2,
      unitSystem
    ) {
      var dtor = Math.PI / 180;
      var radius = unitSystem === "metric" ? 6378.14 : 3959;

      var rlat1 = coords1.latitude * dtor;
      var rlong1 = coords1.longitude * dtor;
      var rlat2 = coords2.latitude * dtor;
      var rlong2 = coords2.longitude * dtor;

      var dlon = rlong1 - rlong2;
      var dlat = rlat1 - rlat2;

      var a =
        Math.pow(Math.sin(dlat / 2), 2) +
        Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(dlon / 2), 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return radius * c;
    },

    // Updates the existing modal pickup with locations with distances from the user
    updateLocationDistances: function updateLocationDistances(coords) {
      var unitSystem = this.$modal
        .find("[data-unit-system]")
        .data("unit-system");
      var self = this;

      this.$modal.find('[data-distance="false"]').each(function () {
        var thisCoords = {
          latitude: parseFloat($(this).data("latitude")),
          longitude: parseFloat($(this).data("longitude")),
        };

        if (thisCoords.latitude && thisCoords.longitude) {
          var distance = self.functions
            .calculateDistance(coords, thisCoords, unitSystem)
            .toFixed(1);

          $(this).html(distance);

          //Timeout to trigger animation
          setTimeout(() => {
            $(this)
              .closest(".store-availability-list__location__distance")
              .addClass("-in");
          }, 0);
        }

        $(this).attr("data-distance", "true");
      });
    },

    // Requests the available stores and updates the page with info below Add to Basket, and append the modal to the page
    updateContent: function updateContent(
      variantId,
      productTitle,
      isSingleDefaultVariant,
      isVariantAvailable
    ) {
      this.$container.off("click", "[data-store-availability-modal-open]");
      this.$container.off(
        "click" + this.namespace,
        ".cc-popup-close, .cc-popup-background"
      );
      $(".store-availabilities-modal").remove();

      if (!isVariantAvailable) {
        //If the variant is Unavailable (not the same as Out of Stock) - hide the store pickup completely
        this.$container.addClass(loadingClass);
        if (this.transitionDurationMS > 0) {
          this.$container.css("height", "0px");
        }
      } else {
        this.$container.addClass(loadingClass);
        if (this.transitionDurationMS > 0) {
          this.$container.css("height", this.$container.outerHeight() + "px");
        }
      }

      if (isVariantAvailable) {
        this.functions.getAvailableStores.call(this, variantId, (response) => {
          if (response.trim().length > 0 && !response.includes("NO_PICKUP")) {
            this.$container.html(response);
            this.$container.html(this.$container.children().first().html()); // editor bug workaround

            this.$container
              .find("[data-store-availability-modal-product-title]")
              .html(productTitle);

            if (isSingleDefaultVariant) {
              this.$container
                .find(".store-availabilities-modal__variant-title")
                .remove();
            }

            this.$container.find(".cc-popup").appendTo("body");

            this.$modal = $("body").find(".store-availabilities-modal");
            var popup = new ccPopup(this.$modal, this.namespace);

            this.$container.on(
              "click",
              "[data-store-availability-modal-open]",
              () => {
                popup.open();

                //When the modal is opened, try and get the users location
                this.functions.getUserLocation().then((coords) => {
                  if (
                    coords &&
                    this.$modal.find('[data-distance="false"]').length
                  ) {
                    //Re-retrieve the available stores location modal contents
                    this.functions.getAvailableStores.call(
                      this,
                      variantId,
                      (response) => {
                        this.$modal
                          .find(".store-availabilities-list")
                          .html(
                            $(response)
                              .find(".store-availabilities-list")
                              .html()
                          );
                        this.functions.updateLocationDistances.bind(this)(
                          coords
                        );
                      }
                    );
                  }
                });

                return false;
              }
            );

            this.$modal.on(
              "click" + this.namespace,
              ".cc-popup-close, .cc-popup-background",
              () => {
                popup.close();
              }
            );

            this.$container.removeClass(loadingClass);

            if (this.transitionDurationMS > 0) {
              var newHeight = this.$container
                .find(".store-availability-container")
                .outerHeight();
              this.$container.css(
                "height",
                newHeight > 0 ? newHeight + "px" : ""
              );
              clearTimeout(this.removeFixedHeightTimeout);
              this.removeFixedHeightTimeout = setTimeout(() => {
                this.$container.css("height", "");
              }, this.transitionDurationMS);
            }
          }
        });
      }
    },
  };

  // Initialise the section when it's instantiated
  this.onSectionLoad(container);
};

// Register section
cc.sections.push({
  name: "store-availability",
  section: theme.StoreAvailability,
});

theme.ProductTemplateSection = new function () {
  this.onSectionLoad = function (container) {
    /// Init store availability if applicable
    if ($('[data-store-availability-container]', container).length) {
      this.storeAvailability = new theme.StoreAvailability($('[data-store-availability-container]', container)[0]);
    }

    // init gallery (before product form - so it can respond to variant images)
    theme.initProductGallery(container);

    // init product form
    $('.product-form', container).trigger('load-product-form');

    theme.ProductBlockManager.loadImages(container);

    // click review rating under title
    $('.theme-product-reviews', container).on('click', 'a', function () {
      $('html,body').animate({
        scrollTop: $($(this).attr('href')).offset().top },
      1000);
      return false;
    });
  };

  this.onSectionUnload = function (container) {
    theme.ProductBlockManager.unloadImages(container);
    theme.destroyProductGallery(container);
    $('.product-form', container).trigger('unload-product-form');
    $('.theme-product-reviews', container).off('click');
    if (this.storeAvailability) {
      this.storeAvailability.onSectionUnload();
    }
  };
}();

theme.Sections.register('main-product', theme.ProductTemplateSection, { deferredLoad: false });


// dom ready
$(function ($) {


  /// Event for initialising options
  $(document).on("load-product-form", ".product-form", function (e) {
    if ($(this).data("product-id") === "") {
      return;
    }

    var $productFormContainer = $(this),
      $productDetail = $(this).closest(".product-detail");

    // events on variant change

    $(this).on("variantChanged", function (evt, variant, product) {
      // change variant status classes
      var $labelCont = $productDetail.find(".product-label-list");
      $labelCont.find(".product-label-container").remove();
      if (variant) {
        $labelCont.append(
          $("#variant-label-".concat(product.id, "-").concat(variant.id)).html()
        );
      } else {
        $labelCont.append(
          $("#variant-label-".concat(product.id, "-none")).html()
        );
      }

      // instate DPBs - requires a variant ID, and may be loaded in quick buy
      if (variant) {
        $productDetail
          .find(".dynamic-payment-button-template")
          .each(function () {
            $(this).after($(this).html()).remove();

            if (Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          });
      }
    });

    // icon-style variant picker to show option beside label
    var $iconOptionContainers = $productDetail.find(".option-selector--swatch");
    if (
      $iconOptionContainers.length &&
      $("body.swatch-style-icon_circle, body.swatch-style-icon_square").length
    ) {
      $iconOptionContainers
        .find(".label")
        .append('<span class="label__value">');
      $(this).on("variantChanged", function (evt, variant) {
        $iconOptionContainers.each(function () {
          var optionIndex = $(this).data("option-index");
          if (variant) {
            var optionValue = variant.options[optionIndex];
            $(this).find(".label__value").text(optionValue);
          } else {
            var selectedOption = this.querySelector(".opt-btn:checked");
            if (selectedOption) {
              $(this).find(".label__value").text(selectedOption.value);
            }
          }
        });
      });
    }

    // Add a disabled-state to options that have no valid variants, in a descending selection order
    var $availabilityDependentOptions = $productDetail.find(
      '.option-selectors[data-disable-unavailable="true"]'
    );
    if ($availabilityDependentOptions.length) {
      $(this).on("variantChanged", function (evt, variant) {
        var _this2 = this;
        var productData = theme.OptionManager.getProductData($(this));
        var optionStatusMap = [];
        var currentSelectedOptionValues = [];

        $(
          '.option-selectors[data-disable-unavailable="true"] .option-selector',
          this
        ).each(function (index) {
          var checkedInput = $(this).find("input:checked");
          var selectedOption = $(this).find(
            '.cc-select__option[aria-selected="true"]'
          );
          var value = checkedInput.length
            ? checkedInput.val()
            : selectedOption
            ? selectedOption.data("value")
            : null;
          currentSelectedOptionValues.push(value);
        });

        // build map of options
        for (
          var optionIndex = 0;
          optionIndex < productData.options.length;
          optionIndex++
        ) {
          var optionName = productData.options[optionIndex];
          var values = {};
          for (var i = 0; i < productData.variants.length; i++) {
            var v = productData.variants[i];
            if (!values[v.options[optionIndex]]) {
              values[v.options[optionIndex]] = false;
            }
          }
          optionStatusMap.push({
            name: optionName,
            values: values,
          });
        }

        // go through each option, assume previous option's values are locked in, if any further choices are possible show as available
        var _loop3 = function _loop3(_optionIndex) {
          var optionName = productData.options[_optionIndex];
          // for this option, find if any variants are available
          var fixedOptions = [];
          for (
            var _i2 = 0;
            _i2 < currentSelectedOptionValues.length && _i2 < _optionIndex;
            _i2++
          ) {
            fixedOptions.push(currentSelectedOptionValues[_i2]);
          }

          // go through each option value
          Object.keys(optionStatusMap[_optionIndex].values).forEach(
            (optionValue) => {
              var fixedOptionsForValue = fixedOptions.map((x) => x);
              fixedOptionsForValue.push(optionValue);

              // go through all variants
              var availableVariantExists = false;
              for (var _i3 = 0; _i3 < productData.variants.length; _i3++) {
                var _v = productData.variants[_i3];
                // does this variant comply with fixedOptionsForValue? (A blank value means it could be fine.)
                var variantComplies = true;
                for (var j = 0; j < fixedOptionsForValue.length; j++) {
                  if (
                    fixedOptionsForValue[j] &&
                    fixedOptionsForValue[j] != _v.options[j]
                  ) {
                    // note typeless compare - can encounter (16 == '16') here
                    variantComplies = false;
                  }
                }
                if (variantComplies && _v.available) {
                  availableVariantExists = true;
                }
              }
              optionStatusMap[_optionIndex].values[optionValue] =
                availableVariantExists;
            }
          );
        };
        for (
          var _optionIndex = 0;
          _optionIndex < productData.options.length;
          _optionIndex++
        ) {
          _loop3(_optionIndex);
        }

        for (var _i = 0; _i < optionStatusMap.length; _i++) {
          var _loop4 = function _loop4(optionValue) {
            $(
              '.option-selector[data-selector-type="listed"][data-option-index="'.concat(
                _i,
                '"] .opt-btn'
              ),
              _this2
            )
              .filter(function () {
                return this.value === optionValue;
              })
              .toggleClass(
                "is-unavailable",
                !optionStatusMap[_i].values[optionValue]
              );
            $(
              '.option-selector[data-selector-type="dropdown"][data-option-index="'.concat(
                _i,
                '"] .cc-select__option'
              ),
              _this2
            )
              .filter(function () {
                return this.dataset.value === optionValue;
              })
              .toggleClass(
                "is-unavailable",
                !optionStatusMap[_i].values[optionValue]
              );
          };
          for (var optionValue in optionStatusMap[_i].values) {
            _loop4(optionValue);
          }
        }
      });
    }

    // when option selector changes, update validation state, but only after first validation called
    $productFormContainer.on("change", ".option-selector", function () {
      if ($productFormContainer.hasClass("product-form--validation-started")) {
        theme.validateProductForm($productFormContainer);
      }
    });

    // initialise options
    theme.OptionManager.initProductOptions($(this));
  });

  $(document).on("unload-product-form", ".product-form", function () {
    $(this).off("variantChanged change");
    theme.OptionManager.unloadProductOptions($(this));
  });

  // when variant changes, and the variant has an image
  $(document).on(
    "variantImageSelected",
    ".gallery",
    function (e, data, isFirstRun) {
      var $gallery = $(this);
      var $galleryCollageContainer = $gallery
        .filter(
          ".gallery--layout-columns-1, .gallery--layout-columns-2, .gallery--layout-collage-1, .gallery--layout-collage-2"
        )
        .find(".product-slideshow:not(.slick-slider)");
      var collageGroupedImagesChanged = false;
      var $slideshow = null;

      if ($gallery.attr("data-variant-image-grouping-option-index") !== "") {
        // when images are grouped, we use options instead of variants
        var pivotOptionIndex = $gallery.attr(
          "data-variant-image-grouping-option-index"
        );
        var selectedGroupOption = data.options[pivotOptionIndex];
        var $thumbnails = $gallery.find(".thumbnails");
        $slideshow = $gallery.find(".slideshow");

        // slideshow - filter
        if ($slideshow.hasClass("slick-slider")) {
          // is variant image visible?
          var currentIsVisible = !!$slideshow.find(
            '.slide[data-media-id="'.concat(data.featured_media.id, '"]')
          ).length;
          // filter (By option name: standard. By media id: when multiple variants have same media)
          $slideshow
            .slick("slickUnfilter")
            .slick(
              "slickFilter",
              '.slide[data-media-id="'
                .concat(
                  data.featured_media.id,
                  '"], [data-variant-image-group="'
                )
                .concat(
                  selectedGroupOption.replace('"', "&quot;").replace(/<>/g, ""),
                  '"]'
                )
            );
          // weird hack required for Slick
          $slideshow
            .find(".slide")
            .css({ position: "", left: "", top: "", zIndex: "", opacity: "" });
          // jump to correct slide immediately after filtering
          if (!currentIsVisible) {
            $slideshow.slick("slickGoTo", 0, true); // reset - hack for a bug
            $slideshow.slick(
              "slickGoTo",
              $slideshow
                .find(
                  '.slide[data-media-id="'.concat(data.featured_media.id, '"]')
                )
                .data("slick-index"),
              true
            );
          }
        }

        // carousel - add/remove as required
        if ($thumbnails.hasClass("owl-carousel")) {
          var $hiddenThumbnails = $gallery.find(".hidden-thumbnails");
          if (!$hiddenThumbnails.length) {
            $hiddenThumbnails = $(
              '<div class="hidden-thumbnails hidden">'
            ).insertAfter($thumbnails);
          }

          // move to hidden thumbnails container (and show() in case hide() called prior)
          $thumbnails
            .find(".thumbnail")
            .show()
            .each(function () {
              if (
                $(this).attr("data-variant-image-group") !=
                  selectedGroupOption &&
                $(this).attr("data-media-id") != data.featured_media.id
              ) {
                var index = $(this).parent().index();
                $(this).appendTo($hiddenThumbnails);
                $thumbnails.trigger("remove.owl.carousel", [index]);
              }
            });

          // add from hidden thumbnails container
          $hiddenThumbnails.find(".thumbnail").each(function () {
            if (
              $(this).attr("data-variant-image-group") == selectedGroupOption ||
              $(this).attr("data-media-id") == data.featured_media.id
            ) {
              $(this).show();
              $thumbnails.trigger("add.owl.carousel", [this]);
            }
          });
          $thumbnails.trigger("refresh.owl.carousel");
        } else {
          // show/hide elements
          $thumbnails.find(".thumbnail").each(function () {
            if (
              $(this).attr("data-variant-image-group") == selectedGroupOption ||
              $(this).attr("data-media-id") == data.featured_media.id
            ) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        }

        // carousel - visibility by class & moving visible to top (for nth-child styling)
        if ($galleryCollageContainer.length) {
          $galleryCollageContainer.find(".slide").each(function () {
            if (
              $(this).attr("data-variant-image-group") == selectedGroupOption ||
              $(this).attr("data-media-id") == data.featured_media.id
            ) {
              if ($(this).hasClass("slide--inactive-option")) {
                collageGroupedImagesChanged = true;
              }
              $(this).removeClass("slide--inactive-option");
            } else {
              if (!$(this).hasClass("slide--inactive-option")) {
                collageGroupedImagesChanged = true;
              }
              $(this).addClass("slide--inactive-option");
            }
          });
          $galleryCollageContainer
            .find(".slide--inactive-option")
            .appendTo($galleryCollageContainer);
        }
      }

      // select matching thumbnail
      $gallery
        .find(
          '.thumbnails a[data-media-id="' + data.featured_media.id + '"]:first'
        )
        .trigger("select");

      // collage - highlight selected, if not first run
      if ($galleryCollageContainer.length) {
        var $active = $gallery.find(
          '.slide[data-media-id="' + data.featured_media.id + '"]:first'
        );
        if ($active.length) {
          if (isFirstRun && !collageGroupedImagesChanged) {
            // only scroll on first run, no visual highlight
            theme.scrollToRevealElement($active[0]);
          } else if (collageGroupedImagesChanged) {
            // assume first image is highlighted by the change
            $gallery
              .find(".slide--was-highlighted")
              .removeClass("slide--was-highlighted");
            $active.addClass("slide--was-highlighted");
          } else if (!$active.hasClass("slide--was-highlighted")) {
            // reset
            clearTimeout(theme.variantImageFadeTimeout);
            $gallery
              .find(".slide--highlight-on")
              .removeClass("slide--highlight-on");
            $gallery
              .find(".slide--highlight-off")
              .removeClass("slide--highlight-off");
            $gallery
              .find(".slide--was-highlighted")
              .removeClass("slide--was-highlighted");

            // highlight
            $active
              .addClass("slide--highlight-on slide--was-highlighted")
              .siblings()
              .addClass("slide--highlight-off");
            theme.variantImageFadeTimeout = setTimeout(function () {
              $gallery
                .find(".slide--highlight-on")
                .removeClass("slide--highlight-on");
              $gallery
                .find(".slide--highlight-off")
                .removeClass("slide--highlight-off");
            }, 1200);

            // scroll if needed
            theme.scrollToRevealElement($active[0]);
          }
        }
      }
    }
  );

  // click main product image (launch gallery)
  $(document).on(
    "click",
    ".product-detail .gallery .main-image a.show-gallery",
    function () {
      var images = [],
        $imgs = $(this)
          .closest(".product-slideshow")
          .find(".slide:not(.slide--inactive-option) .show-gallery"),
        clickedHref = $(this).attr("href");

      if ($imgs.length) {
        $imgs.each(function () {
          var $imgThumb = $(this).find(".rimage-outer-wrapper").clone();
          $imgThumb
            .find(".lazyloaded")
            .removeClass("lazyloaded")
            .addClass("lazyload")
            .parent()
            .addClass("lazyload--placeholder");
          images.push({
            thumbTag: $imgThumb,
            zoomUrl: $(this).attr("href"),
          });
        });
      } else {
        var $img = $(this).find(".rimage-outer-wrapper").clone();
        $img
          .find(".lazyloaded")
          .removeClass("lazyloaded")
          .addClass("lazyload")
          .parent()
          .addClass("lazyload--placeholder");
        images.push({
          thumbTag: $img,
          zoomUrl: $(this).attr("href"),
        });
      }

      theme.buildGalleryViewer({
        images: images,
        currentImage: clickedHref,
        prev: theme.icons.chevronLeft,
        next: theme.icons.chevronRight,
        close: theme.icons.close,
      });

      return false;
    }
  );
})